import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { Categoria, ProcesoBase, ProcesoCategoria, TramiteBase, TramiteProceso } from '@app/shared';

@Injectable()
export class ManageSecondaryDetailDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

    /**
   * Retorna las categorias asociadas a los tramites por default.
   *
   * @param {boolean} [validUser=false] - Para realizar la consulta validando por usuario
   * @returns {Observable<Categoria[]>}
   * @memberof ManageSecondaryDetailDataService
   */
  getCategories(validUser: boolean = false): Observable<Categoria[]> {
    return new Observable(obs => {
      let endPoint = 'category';
      if (validUser) {
        endPoint = 'categoryUser';
      }
      this.http.get<Categoria[]>(this.api.get(endPoint)).subscribe(
        categories => {
          obs.next(categories);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Retorna las procesos asociados a los tramites por default.
   * Dichos procesos son filtrados con el id de la categoria.
   *
   * @param {number} idCategoria
   * @param {boolean} [validUser=false] - Para realizar la consulta validando por usuario
   * @returns {Observable<ProcesoBase[]>}
   * @memberof ManageSecondaryDetailDataService
   */
  getProcess(idCategoria: number, validUser: boolean = false): Observable<ProcesoBase[]> {
    return new Observable(obs => {
      if (validUser) {
        this.http.get<ProcesoBase[]>(this.api.get('processUser', [idCategoria])).subscribe(
          data => {
            obs.next(data);
          },
          err => {
            obs.error(err);
          }
        );
      } else {
        this.http.get<ProcesoCategoria>(this.api.get('processCategory', [idCategoria])).subscribe(
          data => {
            obs.next(data.procesos);
          },
          err => {
            obs.error(err);
          }
        );
      }
    });
  }
  /**
   * Retorna los tramites por default sin las actividades.
   * Dichos tramites son filtrados por el id del preceso.
   *
   * @param {number} idProceso
   * @param {boolean} [validUser=false] - Para realizar la consulta validando por usuario
   * @returns {Observable<TramiteBase[]>}
   * @memberof ManageSecondaryDetailDataService
   */
  getDefaultTrtamites(idProceso: number, validUser: boolean = false): Observable<TramiteBase[]> {
    return new Observable(obs => {
      let endPoint = 'tramiteProcess';
      if (validUser) {
        endPoint = 'tramiteUserProcess';
      }
      this.http.get<TramiteProceso>(this.api.get(endPoint, [idProceso])).subscribe(
        data => {
          obs.next(data.tramites);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta un tramite por default.
   *
   * @param {number} id
   * @returns {Observable<any>}
   * @memberof ManageSecondaryDetailDataService
   */
  getDetail(id: number): Observable<any> {
    return new Observable(obs => {
      this.http.get<any>(this.api.get('adminSecondaryDetail',[id])).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

   /**
   * Agregar un tramite al detalle de secundaria
   *
   * @param {any} data
   * @returns {Promise<boolean>}
   * @memberof ManageSecondaryDetailDataService
   */
   addDetail(data:any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('adminSecondaryDetail'), data).subscribe(
        _resp => {
          this.toastr.success('Trámite agregado correctamente','Operación exitosa');
          resolve(true);
        },
        err => {
          if(err.status == 400){
            this.toastr.warning(err.error, 'Error en la operación');
          }else{
            this.toastr.error("No fue posible realizar el registro de trámite",'Error en la operación');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Eliminar un tramite al detalle de secundaria
   *
   * @param {number} id
   * @returns {Promise<boolean>}
   * @memberof ManageSecondaryDetailDataService
   */
  deleteDetail(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get('adminSecondaryDetail', [id])).subscribe(
        _resp => {
          this.toastr.success('Registro eliminado correctamente','Operación exitosa');
          resolve(true);
        },
        err => {
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-secondary-detail/shared/manage-secondary-detail.data.service.ts